"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initializeGoogleConsent = void 0;
const constants_1 = require("../../constants");
const initializeGoogleConsent = () => {
    if (!window.dataLayer) {
        window.dataLayer = [];
    }
    if (!window.gtag) {
        window.gtag = function gtag() {
            window.dataLayer.push(arguments);
        };
    }
    // gtag should set default Google Consent Mode settings before Google Tags or OneTrust loads
    // https://my.onetrust.com/s/article/UUID-d81787f6-685c-2262-36c3-5f1f3369e2a7
    window.gtag('consent', constants_1.GoogleConsentCommand.default, {
        analytics_storage: constants_1.GoogleConsentTypes.denied,
        ad_storage: constants_1.GoogleConsentTypes.denied,
        functionality_storage: constants_1.GoogleConsentTypes.denied,
        personalization_storage: constants_1.GoogleConsentTypes.denied,
        security_storage: constants_1.GoogleConsentTypes.denied,
        ad_user_data: constants_1.GoogleConsentTypes.denied,
        ad_personalization: constants_1.GoogleConsentTypes.denied,
    });
};
exports.initializeGoogleConsent = initializeGoogleConsent;
//# sourceMappingURL=initializeGoogleConsent.js.map